import { contractTemplateInitialStatus as initialStatus } from './contractTemplateInitialStatus';
import { contractTemplateInitialValues as initialValues } from './contractTemplateInitialValues';

export default { initialStatus, initialValues };
